<script></script>

<div class="container">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    ><title>edit-brightness</title><g fill="currentColor"
      ><path
        d="M13,6a.75.75,0,0,1-.75-.75,1.5,1.5,0,0,0-1.5-1.5.75.75,0,0,1,0-1.5,1.5,1.5,0,0,0,1.5-1.5.75.75,0,0,1,1.5,0,1.5,1.5,0,0,0,1.5,1.5.75.75,0,0,1,0,1.5,1.5,1.5,0,0,0-1.5,1.5A.75.75,0,0,1,13,6Z"
        data-color="color-2"
      /><path
        d="M6,16a1,1,0,0,1-1-1,4,4,0,0,0-4-4A1,1,0,0,1,1,9,4,4,0,0,0,5,5,1,1,0,0,1,7,5a4,4,0,0,0,4,4,1,1,0,0,1,0,2,4,4,0,0,0-4,4A1,1,0,0,1,6,16Z"
        fill="currentColor"
      /></g
    ></svg
  >
  <p>Select a template to edit colors, text, fonts & more</p>
</div>

<style>
  .container {
    position: fixed;
    top: 75px;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    padding: 14px 28px;
    background-color: #0f1010;
    width: 100%;
    min-height: 75px;
  }

  .container p,
  .container svg {
    opacity: 0.6;
  }
</style>
